import { message } from "antd";
import { getAllResponsesByProjectIdLocal, trainigonGetAllResponsesByProjectId, updateApiWhitLocalResponses } from "../../api/petitionsTraining";
import { formatingHeaders } from "../helpers";
import { onSetArrayData } from "../tableSlice/tableSlice";
import { addResponsesTraining, setProyectSelectedTraining } from "./vrtSlice";

export const getAllResponsesTrainingFormProject = (payload) => {
	return async (dispatch, getState) => {
		const response = await trainigonGetAllResponsesByProjectId(payload);
        console.log("respuestas Training " + payload);
        dispatch(setProyectSelectedTraining(payload))
		if (response.status === 0) {
			dispatch(addResponsesTraining(response.payload.responses));
			const headers = formatingHeaders(response.payload.responses);
			// dispatch(onSetArrayHeaders(headers));
            if (payload === "66fafd1d92bbc20883798c43") {
                dispatch(onSetArrayData(formatinDataCemex(response.payload.responses, headers)));
            }
            if (payload === "67367c71fa5b23562aee086c") {
                // FResnillo
                dispatch(onSetArrayData(formatinDataFresnilloAmacice(response.payload.responses, headers)));
            }
            else {
                dispatch(onSetArrayData(formatinData(response.payload.responses, headers)));
            }
			return true;
		} else {
			message.error("No se consiguieron datos, recarga la pagina");
			return false;
		}
	};
};

// Update DB
export const updateApiDBwhenIsConected = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const { payload } = await getAllResponsesByProjectIdLocal(1);
		if (state.vrtSlice.responses.length === payload.responses.length) {
			return;
		}
		// console.log("*/******");
		console.log(payload.responses);
		updateApiWhitLocalResponses(payload.responses);
	};
};

//

const formatinData = (responses, headersFormated) => {
	const data = [];
	responses.forEach((response, i) => {
		const res = {};
		res.Nombre = response.nameUser;
		// res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);
        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());
        res.Fecha_y_hora = fechaGMT;
        res.matricula = response.matricula;
        res._idUser = response.student ? response.student._id : null
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";

        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
        }

        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);
        res.Porcentaje_total = `${percentage}%`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};


const formatinDataCemex = (responses, headersFormated) => {
    console.log("formating CEMEX data----")
    const data = [];
    responses.forEach((response, i) => {
        const res = {};
        res.Nombre = response.nameUser;
        // res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);

        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());

        // const dateStyled = new Date(fechaGMT);
        res.Fecha_y_hora = fechaGMT;
        res.matricula = response.matricula;
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";

        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
        }
        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);

        res.Porcentaje_total = `${headersFormated.filter(header => header.isQuestion).length * 100 / 15}%`;
        res.puntaje = `${percentage}/100`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};

const formatinDataFresnilloAmacice = (responses, headersFormated) => {
    console.log(responses)
    const data = [];
    responses.forEach((response, i) => {
        const res = {};
        res.Nombre = response.nameUser;
        // res.tiempo_total = response
        let fechaGMT = new Date(response.createdAt);
        // Convertir de GMT a GMT-6 (restar 6 horas)
        fechaGMT.setHours(fechaGMT.getHours());
        res.Fecha_y_hora = fechaGMT;
        res.profesor = response.profesor;
        res.matricula = response.matricula;
        const questions = response.responses;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;
        let answersSumatoria = 0;

        res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";
        headersFormated.forEach((header) => {
            if (header.isQuestion) {
                res[`${header.key}`] = questions[header.title] ? questions[header.title].answer : "*";
                // si las respuestas son numeros hace la sumatoria
                if (questions[header.title] && questions[header.title].answer && !isNaN(questions[header.title].answer)) {
                    answersSumatoria += parseInt(questions[header.title].answer);
                }
                //
                if (questions[header.title] && questions[header.title].answer === questions[header.title].correctAnswer) {
                    correctAnswers++;
                } else {
                    if (questions[header.title]) {
                        incorrectAnswers++;
                    }
                }
            }
        });

        // si la sumatoria es mayor a 0 (significa que las respuestas son numericas) y las despliega en la tabla
        if (answersSumatoria > 1) {
            res.sumatoria = answersSumatoria;
            res.puntaje = answersSumatoria
        }
        const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);
        res.Porcentaje_total = `${percentage}%`;
        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    return data;
};
